import { GlobalConstants } from '../app/shared/global-constants';

export interface envUrlConfigType {
  termsAndConditionsUrl;
  eeoiFormSectionsUrl;
  eeoiFormElementsUrl;
  eeoiHelpUrl;
  questionAnswerGroupsUrl;
  questionAnswersUrl;
};

export function uiLoggerUrl() {return '/ui-logger'}
export function agencyLocationsUrl (policyNumber:Number) { return `/policies/${policyNumber}/agency-locations`; };
export function groupUrl (policyNumber:Number) { return `/policies/${policyNumber}/group`; };
export function policyEdpUrl (policyNumber:Number) { return `/policies/${policyNumber}`; };
export function featureFlagUrl (flagName:String) { return `/mhs/featureFlag/${flagName}`; };
export function isValidEmailAddress(email:String) {return `/mhs/validateEmail?email=${email}`;};
export function mhsQuestionsUrl (state: string, policyNumber:Number, carrier:string) {
  for (let nextState of GlobalConstants.US_STATE_OF_RESIDENCE) {
    if (state === nextState.abbreviation) {
      switch (carrier) {
        case 'SNY':
          return `/mhs/v2/form?state=${state}&policy=${policyNumber}&carrier=${carrier}`;
        case 'NM':
          if(state !== 'IL' && state !== 'MA' && state !== 'NY'){
            return `/mhs/v2/form?state=${state}&policy=${policyNumber}&carrier=${carrier}`;
          }
          break;
        default:
          return `/mhs/v2/form?state=${state}&policy=${policyNumber}&carrier=${carrier}`;
      }
    }
  }
  return `/mhs/v2/form?state=${state}&policy=${policyNumber}&carrier=${carrier}`;
};
export function mhsApplicationWithExStreamCloudUrl (formNumber:string) { return `/mhs/v2/form/${formNumber}/application`; };
export function mhsPartialApplicationWithExStreamCloudUrl (formNumber:string) { return `/mhs/v2/form/${formNumber}/partialapplication`; };
export function mhsFinalApplicationWithExStreamCloudUrl (mhsId:string, stateOfResidence:string, policyNumber:string, companyId:string) { return `/mhs/v2/partialApplication/mhsId/${mhsId}/stateOfResidence/${stateOfResidence}/policyNumber/${policyNumber}/companyId/${companyId}`; };
export function updateMhsPartialApplicationWithExStreamCloudUrl (formNumber:string, mhsId:string, stage:string) { return `/mhs/v2/form/${formNumber}/partialapplication/${mhsId}/stage/${stage}`; };
export function updateEmployeeWithExStreamCloudUrl (mhsId:string) { return `/mhs/v2/form/updateEmployee/${mhsId}`; };
export function updateApplicantWithExStreamCloudUrl (mhsId:string) { return `/mhs/v2/form/updateApplicant/${mhsId}`; };
export function updateMedicalHistoryWithExStreamCloudUrl (mhsId:string, isNewGenericDynamicForm:boolean) { return `/mhs/v2/form/updateMedicalHistory/${mhsId}/isNewGenericDynamicForm/${isNewGenericDynamicForm}`; };
export function updatePhysicianWithExStreamCloudUrl (mhsId:string) { return `/mhs/v2/form/updatePhysician/${mhsId}`; };
export function updateAcknowledgementsWithExStreamCloudUrl (mhsId:string) { return `/mhs/v2/form/updateAcknowledgements/${mhsId}`; };
export function updateElectronicCommunicationWithExStreamCloudUrl (mhsId:string) { return `/mhs/v2/form/updateElectronicCommunication/${mhsId}`; };
export function updateEconsentWithExStreamCloudUrl (mhsId:string) { return `/mhs/v2/form/updateEconsent/${mhsId}`; };
export function updateFlowStatusToReady (mhsId:string) { return `/mhs/v2/form/updateFlowStatusToReady/${mhsId}`; };
export function mhsCloudPdfUrl (formNumber:string, mhsId:string) { return `/mhs/v2/form/${formNumber}/application/${mhsId}`; };
export function getEnvironmentUrl (url: string, deployPath: string) {
  let urlConfig = url;

  // don't concat deploy path if url is full url
  if(urlConfig.indexOf('https://') === 0) {
    return urlConfig;
  }

  return deployPath.concat(urlConfig)
};
export function getApiUrl (url: string, deployPath: string, apiSubscriptionId?: string) {

  // API utilizes CORS. Endpoint depends on deployment config
  // TODO - ensure we trust the endpoint. Can domains be restricted?
  if( (!!deployPath)===false || deployPath.indexOf('https://') !== 0
      || (!!url)===false || url.indexOf('/') !== 0) {
    throw new Error('invalid api endpoint');
  }

  return deployPath.concat(url);
};

export const environment = {
  production: true,
  name: 'production',
  appEnv: 'int',  // TODO - make this dynamic based on where deployed?
  appCode: 'eeoi',
  drupalServer: 'https://cm.standard.com',
  drupalEnv: 'int',  // TODO - make this dynamic based on where deployed?
  apiCallTimeoutTimeInSeconds: 30000,
  timeoutTimeInSeconds: 1800,
  timeoutWarningTimeInSeconds: 120,

  // http urls
  agencyLocationsUrl: agencyLocationsUrl,
  groupUrl: groupUrl,
  policyEdpUrl: policyEdpUrl,
  featureFlagUrl: featureFlagUrl,
  isValidEmailAddress: isValidEmailAddress,
  mhsQuestionsUrl: mhsQuestionsUrl,
  mhsApplicationWithExStreamCloudUrl: mhsApplicationWithExStreamCloudUrl,
  mhsPartialApplicationWithExStreamCloudUrl: mhsPartialApplicationWithExStreamCloudUrl,
  mhsFinalApplicationWithExStreamCloudUrl: mhsFinalApplicationWithExStreamCloudUrl,
  updateMhsPartialApplicationWithExStreamCloudUrl: updateMhsPartialApplicationWithExStreamCloudUrl,
  updateEmployeeWithExStreamCloudUrl: updateEmployeeWithExStreamCloudUrl,
  updateApplicantWithExStreamCloudUrl: updateApplicantWithExStreamCloudUrl,
  updateMedicalHistoryWithExStreamCloudUrl: updateMedicalHistoryWithExStreamCloudUrl,
  updatePhysicianWithExStreamCloudUrl: updatePhysicianWithExStreamCloudUrl,
  updateAcknowledgementsWithExStreamCloudUrl: updateAcknowledgementsWithExStreamCloudUrl,
  updateElectronicCommunicationWithExStreamCloudUrl: updateElectronicCommunicationWithExStreamCloudUrl,
  updateEconsentWithExStreamCloudUrl: updateEconsentWithExStreamCloudUrl,
  updateFlowStatusToReady: updateFlowStatusToReady,
  mhsCloudPdfUrl: mhsCloudPdfUrl,
  getEnvironmentUrl: getEnvironmentUrl,
  getApiUrl: getApiUrl,
  uiLoggerUrl: uiLoggerUrl
};
